import API from "./API";
import { debounce } from "lodash";

// ===========================Contra Voucher==================================
// ✅ 1. Filtered Proforma Invoice List by Party
export const FilteredProformaInvoiceList = async (partyId, projectId) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // ✅ Agar partyId nahi hai, empty array return karo
  if (!partyId) {
    console.warn("⚠️ Party ID required for PI list");
    return [];
  }

  try {
    const response = await API.get(
      `accountent/api/proforma-invoices/filtered/`,
      {
        params: { party_id: partyId, project_id: projectId }, // ✅ Hamesha party_id bhejo
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("❌ FilteredProformaInvoiceList error:", err);
    return [];
  }
};
export const FilteredSalesVoucherList = async (partyId) => {
  const access = JSON.parse(localStorage.getItem("access"));

  if (!partyId) {
    return { results: [], count: 0 };
  }

  try {
    const response = await API.get(`accountent/api/sales-vouchers/filtered/`, {
      params: { party_id: partyId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response?.data || { results: [], count: 0 };
  } catch (err) {
    console.error("❌ FilteredSalesVoucherList error:", err);
    return { results: [], count: 0 };
  }
};
// get all contra voucher

export const GetContraVoucherNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      `accountent/contra-voucher-no/`, // 👈 match this with your Django route
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );

    return response.data; // { cv_voucher_no: "KP&G/CV/25-26/1" }
  } catch (err) {
    console.error("Error fetching Contra Voucher No:", err);
    return null;
  }
};

export const ApproveContraVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-contra/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );
  return response?.data || {};
};
export const ContraVoucherList = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/contra-voucher/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
      voucher_no: filters.voucher_no || "",
      account_no: filters.account_no || "",
      status: filters.status || "",
      contra_date_from: filters.contra_date_from || "",
      contra_date_to: filters.contra_date_to || "",
    },
  }).catch((err) => {
    console.error("Contra Voucher List Error:", err);
  });

  return response ? response.data : [];
};

export const CreateContraVoucher = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post(`accountent/contra-voucher/`, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data; // success response
  } catch (err) {
    console.error("Create Contra Voucher Error:", err);
    return { error: true, message: err.message };
  }
};

export const DeleteContraVoucher = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.delete(`accountent/contra-voucher/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return response.data;
  } catch (err) {
    console.error("Delete Contra Voucher Error:", err);
    return {};
  }
};

export const UpdateContraVoucher = async (id, updatedData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(
      `accountent/contra-voucher/${id}/`, // 👈 Django route ke hisab se
      updatedData, // e.g. { amount: 500, remarks: "Updated" }
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );

    return response.data; // { success: "...", data: {...} }
  } catch (err) {
    console.error("Update Contra Voucher Error:", err);
    return {};
  }
};

// user login api- check by mr_vk in 20-8-2025
export const userLogin = async (formData) => {
  try {
    const response = await API.post(`account/login/`, formData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// create by mr_vk in 20-8-2025
export const ProfileCreate = async (fromData) => {
  const response = await API.post(`account/register/`, fromData, {
    headers: {
      "Content-Type": "application/json",
    },
  }).catch();
  return response ? response.data : {};
};

export const fetchUserList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`account/user-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : [];
};

export const UpdateUserStatus = async (id, checked) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(
    `account/update-user/${id}/`,
    { is_active: checked },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("Update User Error:", err);
  });
  return response ? response.data : {};
};

export const LedgerName = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/ledger-name/`, {
    params: params, // ✅ Pass search & other query parameters
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
export const LedgerList = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/ledger-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: params, // ✅ Pass search & other query parameters
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ProfileList = async (page = 1, search = "") => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(`account/register/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: { page, search }, // ✅ limit hata diya
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching profiles:", error);
    return { results: [], next: null };
  }
};

export const ProfileDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`account/register/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const ProfileUpdate = async (role_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`account/register/${role_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// user pages permission create and get api check by mr_vk in 20-8-2025
export const createPermission = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`account/permissions/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : [];
};

// login api

// export const fetchPermission = async (id) => {

//   const access = JSON.parse(localStorage.getItem("access"));
//   try {
//     const response = await API.get(`account/permissions/${id}/`, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${access}`,
//       },
//     });
//     return response?.data || []; // yahi pe .data return kar do
//   } catch (err) {
//     console.error("API error:", err);
//     return []; // empty array safe return
//   }
// };
export const fetchPermission = async (id) => {
  // ✅ 1. Logout check
  if (sessionStorage.getItem("loggingOut")) {
    console.log("Logout in progress, skipping API call");
    return [];
  }

  // ✅ 2. ID null check
  if (!id || id === "null" || id === null || id === undefined) {
    console.log("Invalid user ID, skipping API call");
    return [];
  }

  // ✅ 3. Token check
  const access = JSON.parse(localStorage.getItem("access"));
  if (!access || access === "null" || access === null) {
    console.log("No valid token, skipping API call");
    return [];
  }

  try {
    const response = await API.get(`account/permissions/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};

export const fetchJournalVouchersBySupplier = async (supplierId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `accountent/general-vouchers-balance/?supplier_id=${supplierId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};
export const fetchJournalVouchersByAdvanceWorker = async (advanceWorkerId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `accountent/general-vouchers-balance/?advance_worker_id=${advanceWorkerId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};

export const fetchJournalVouchersByTransporter = async (transporterId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `accountent/general-vouchers-balance/?transporter_id=${transporterId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};
// ✅ Get Journal Vouchers by Imprest ID
export const fetchJournalVouchersByImprest = async (imprestId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `accountent/general-vouchers-balance/?imprest_id=${imprestId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};

export const fetchPurchaseVouchersBySupplier = async (supplierId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `accountent/purchase-vouchers-balance/?supplier_id=${supplierId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response?.data || [];
  } catch (err) {
    console.error("API error:", err);
    return [];
  }
};

// create by himanshu in 25-6-2025

export const DivisionCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`account/divisions/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const DivisionList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`account/divisions/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const DivisionDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`account/divisions/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const DivisionUpdate = async (division_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`account/divisions/${division_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Expense CRUD operations

export const ExpenseCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`accountent/expense/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const ExpenseList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`accountent/expense/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const ExpenseDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`accountent/expense/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const ExpenseUpdate = async (expense_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(
    `accountent/expense/${expense_id}/`,
    fromData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};

// category crud opration
export const getCategories = async (page = 1, search = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/categories/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        search,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return { results: [], count: 0, next: null, previous: null };
  }
};

export const createCategory = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/categories/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const updateCategory = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/category/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const deleteCategory = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/category/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// subcategory crud opration
export const getsubCategories = async (
  page = 1,
  subcategory = "",
  category = "",
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`inventory/subcategories/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: { page, subcategory, category }, // ✅ backend params
    });
    return response.data; // {results, next, previous, count}
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return { results: [], next: null, previous: null, count: 0 };
  }
};

export const createsubCategory = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/subcategories/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const updatesubCategory = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/subcategory/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const deletesubCategory = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/subcategory/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const fetchSubCategories = async (categoryId, page = 1, search = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`inventory/subcategories/${categoryId}`, {
    headers: { Authorization: `Bearer ${access}` },
    params: {
      page,
      limit: 20,
      search,
    },
  });
  return response.data;
};

export const fetchItemsByCategoryAndSubcategory = async (
  categoryId,
  subcategoryId,
  page = 1,
  search = "",
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `inventory/itemsbysubcategory/${categoryId}/${subcategoryId}/`,
    {
      params: {
        page,
        limit: 20,
        search,
      },
      headers: { Authorization: `Bearer ${access}` },
    },
  );
  return response.data; // { results, total, page, limit }
};

// units crud opration
export const getUnits = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`inventory/units/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const getSizes = async (search = "") => {
  const access = JSON.parse(localStorage.getItem("access"));

  const res = await API.get(`inventory/sizes/`, {
    headers: { Authorization: `Bearer ${access}` },
    params: {
      search: search || "",
    },
  });

  return res.data;
};

export const getItemType = async (search = "") => {
  const access = JSON.parse(localStorage.getItem("access"));

  const res = await API.get(`inventory/item-type/`, {
    headers: { Authorization: `Bearer ${access}` },
    params: search ? { search } : {},
  });

  return res.data;
};

export const createUnit = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/units/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const createSize = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/sizes/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const createItemType = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/item-type/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const updateUnit = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/unit/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const updateSize = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/sizes/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const updateItemType = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/item-type/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const deleteUnit = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/unit/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const deleteSize = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/sizes/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const deleteItemType = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/item-type/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const getDivisionUnits = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`inventory/division-units/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// sales-order create,list ,delete,update,detail api,and approve so api and list api

export const SalesOrderCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`sale/sales-orders/`, formData, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const SalesOrderListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("sale/sales-orders/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party: filters.party || "",
        division: filters.division || "",
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        so_date: filters.so_date || "",
        so_no: filters.so_no || "",
        project_name: filters.project_name || "",
        status: filters.status || "",
        po_date_from: filters.po_date_from || "",
        po_date_to: filters.po_date_to || "",
        // order_date: filters.order_date || "",
      },
    });

    return response.data;
  } catch (err) {
    console.error("Error fetching sales orders:", err);
    return { results: [], next: null }; // next for infinite scroll
  }
};

export const ReportSalesOrderListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("report/sales-orders-report/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        company_name: filters.company_name || "",
        client_name: filters.client_name || "",
        id: filters.id || "",
        project_name: filters.project_name || "",
      },
    });

    return response.data;
  } catch (err) {
    console.error("Error fetching sales orders:", err);
    return { results: [], next: null }; // next for infinite scroll
  }
};
export const ApproveSo = async (soId, approverId, status, remarks) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(
    `sale/approve-so/${soId}/`, // ✅ same endpoint for toggle
    {
      authorized_by: approverId, // kisne approve/unapprove kiya
      status: status,
      remarks, // true = approve, false = unapprove
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

export const ApproveSolistapi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale/approve-so/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      project_name: filters.project_name || "",
      division: filters.division || "",
      search: filters.search || "",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const ApproveIndentlistapi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`purchase/approve-indent/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      indent_no: filters.indent_no || "",
      division: filters.division || "",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const PendingSoListapi = async (page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale/pending-so/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
    },
  }).catch(() => null);
  return response ? response.data : {};
};
export const SalesOrderDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`sale/sales-orders/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const SalesOrderUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`sale/sales-orders/${id}/`, formData, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const SalesOrderDetail = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale/sales-orders/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

//party

export const fetchParty = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("sale/party/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        name: filters.name || "",
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching Partys:", err);
    return { results: [], next: null }; // next for infinite scroll
  }
};
export const PartyCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`sale/party/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const PartyUpdate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`sale/party/${id}/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const deleteParty = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`sale/party/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const ApproveSuplierapi = async (id, authorized_by, status, remarks) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const authId = parseInt(authorized_by, 10);
  if (!Number.isInteger(authId)) {
    throw new Error("authorized_by invalid (not an integer)");
  }

  // If backend expects lowercase ("approved"/"rejected"/"pending"), uncomment next line:
  // const normalizedStatus = String(status || "").toLowerCase();
  const normalizedStatus = status; // keep as-is if backend expects "Approved"/"Rejected"

  const response = await API.patch(
    `purchase/approve/suppliers/${id}/`,
    {
      authorized_by: authId, // ✅ correct key + integer
      status: normalizedStatus,
      remarks: remarks || "",
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response ? response.data : {};
};
export const ApprovePartyapi = async (id, authorized_by, status, remarks) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const authId = parseInt(authorized_by, 10);
  if (!Number.isInteger(authId)) {
    throw new Error("authorized_by invalid (not an integer)");
  }

  // If backend expects lowercase ("approved"/"rejected"/"pending"), uncomment next line:
  // const normalizedStatus = String(status || "").toLowerCase();
  const normalizedStatus = status; // keep as-is if backend expects "Approved"/"Rejected"

  const response = await API.patch(
    `sale/approve/party/${id}/`,
    {
      authorized_by: authId, // ✅ correct key + integer
      status: normalizedStatus,
      remarks: remarks || "",
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response ? response.data : {};
};

//indent api for next indent no
export const GetNextIndentNo = async (divisionId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    // token
    const response = await API.get(`purchase/indent/next-indent-no/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: { division: divisionId }, // ✅ division id send
    });
    return response.data; // { indent_no: "AUG-25-MFG-I-01" }
  } catch (err) {
    console.error("Failed to fetch next indent number:", err);
    return null;
  }
};

// Indent Crud opration
// create by mr_vk in 20-6-2025
export const IndentCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`purchase/indents/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// export const IndentListApi = async (page = 1, filters = {}) => {
//   const access = JSON.parse(localStorage.getItem("access"));

//   try {
//     const response = await API.get("purchase/indents/", {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${access}`,
//       },
//       params: {
//         page,
//         indent_no: filters.indent_no || "",
//         project_name: filters.project_name || "",
//         status: filters.status || "",
//       },
//     });
//     return response.data;
//   } catch {
//     return { results: [] };
//   }
// };
export const IndentListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("purchase/indents/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        indent_no: filters.indent_no || "",
        project_name: filters.project_name || "",
        status: filters.status || "",

        // 🆕 Date filtering parameters
        date_range: filters.date_range, // default: this_month
        from_date: filters.from_date || "", // for custom range
        to_date: filters.to_date || "", // for custom range
      },
    });
    return response.data;
  } catch (error) {
    console.error("IndentListApi Error:", error);
    return { results: [] };
  }
};

export const IndentReportsListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("report/indentsreports/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        indent_no: filters.indent_no || "",
        project_name: filters.project_name || "",
      },
    });
    return response.data;
  } catch {
    return { results: [] };
  }
};

export const IndentDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`purchase/indents/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const IndentUpdate = async (indentId, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`purchase/indents/${indentId}/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  });
  return response?.data || [];
};

export const ApproveIndent = async (indentId, approverId, status, remarks) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `purchase/approve-indent/${indentId}/`,
    {
      authorized_by: approverId, // kisne approve/unapprove kiya
      status: status,
      remarks, // true = approve, false = unapprove
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

// project summary report api
export const ProjectSummaryRpt = async (id, params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`report/project/summary/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: params, // ✅ Pass search & other query parameters
  }).catch(() => null);
  return response ? response.data : {};
};
export const ProjectSummaryStats = async (projectId, params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`report/projects/summary/${projectId}/stats/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params,
  });
  return res.data;
};

// Quotation Crud opration
// create by mr_vk in 20-6-2025
export const QuotationCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`academic/quotations/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const QuotationListApi = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`academic/quotations/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const QuotationDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`academic/quotations/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const QuotationUpdate = async (role_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`academic/quotations/${role_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// ✅ Create Enquiry
export const createEnquiry = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.post(`academic/enquiry/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Enquiry Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Get All Enquiries
export const getAllEnquiries = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`academic/enquiry/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Get All Enquiries Error:", err);
  });
  return response ? response.data : [];
};

// ✅ Get Single Enquiry by ID
export const getEnquiryById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`academic/enquiry/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Get Single Enquiry Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Update Enquiry
export const updateEnquiry = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`academic/enquiry/${id}/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Update Enquiry Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Delete Enquiry
export const deleteEnquiry = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`academic/enquiry/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Delete Enquiry Error:", err);
  });
  return response ? response.status === 204 : false;
};

// ✅ Create Feedback
export const createFeedback = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.post(`academic/feedbacks/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Feedback Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Get All Feedbacks
export const getAllFeedbacks = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`academic/feedbacks/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Get All Feedbacks Error:", err);
  });
  return response ? response.data : [];
};

// ✅ Get Single Feedback by ID
export const getFeedbackById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`academic/feedbacks/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Get Single Feedback Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Update Feedback
export const updateFeedback = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`academic/feedbacks/${id}/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Update Feedback Error:", err);
  });
  return response ? response.data : {};
};

// ✅ Delete Feedback
export const deleteFeedback = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`academic/feedbacks/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Delete Feedback Error:", err);
  });
  return response ? response.status === 204 : false;
};

//General Voucher Crud operations
//created by anjali 12-07-2025
export const GeneralVoucherReportList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`report/general-vouchers-report/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

// 🔸 Get All General Vouchers
export const GeneralVoucherList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/general-vouchers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      gen_number: filters.voucherSearch || "",
      bill_no: filters.billNoSearch || "",
      status: filters.statusFilter || "",
      project: filters.projectSearch || "",
      division_id: filters.divisionFilter || filters.division_id || "",
      date_range: filters.date_range || "",
      ledger: filters.ledgerSearch || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
      // bill_date: filters.billdate || "",
      bill_date_from: filters.bill_date_from || "",
      bill_date_to: filters.bill_date_to || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

// 🔸 Create General Voucher
export const GeneralVoucherCreate = async (formDataObj) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post(
      "accountent/general-vouchers/",
      formDataObj,
      {
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error("Backend validation error:", err.response.data);
    } else {
      console.error("Request error:", err.message);
    }
    throw err;
  }
};

// 🔸 Update General Voucher (PUT or PATCH)
export const GeneralVoucherUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(
      `accountent/general-vouchers/${id}/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error(" Update error:", err.response?.data || err.message);
    throw err;
  }
};

// 🔸 Delete General Voucher

export const GeneralVoucherDelete = async (gen_voucher_no) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.delete(
      `accountent/general-vouchers/${gen_voucher_no}/`,
      {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      },
    );

    return response.status === 204 || response.status === 200;
  } catch (error) {
    console.error(
      "Delete API Error:",
      error.response?.status,
      error.response?.data || error.message,
    );
    return false;
  }
};

export const GetNextGeneralNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/generate-general-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};

export const ApproveGeneralVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-general/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

export const GetApproveGVs = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/approve-general/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
// ===========================Purchase Voucher==================================

// get all purchase voucher
export const GetPurchaseVoucherList = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/purchase-vouchers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
      po_no: filters.po_no,
      grn_no: filters.grn_no,
      supplier: filters.supplier,
      status: filters.status,
      invoice_date: filters.invoice_date,
      purchase_number: filters.purchase_number,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

// Add this to your Services.js file

export const ExportPurchaseVoucherList = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      "accountent/purchase-vouchers/pending-grn-export/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          date_range: filters.date_range || "",
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
          grn_no: filters.grn_no || "",
          supplier: filters.supplier || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Purchase Voucher Export Error:", error);
    throw error;
  }
};

export const ApproveTransporterList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/inventory/transporter/approved/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
// get purchase voucher by id

export const GetPurchaseVoucherById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(`accountent/purchase-vouchers/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(`Fetch Error for ID ${id}:`, err);
    return null;
  }
};

// Services.js

// ✅ Export Purchase Vouchers to Excel
export const exportPurchaseVouchers = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("accountent/purchase-vouchers/export/", {
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        purchase_number: filters.purchase_number || "",
        po_no: filters.po_no || "",
        grn_no: filters.grn_no || "",
        supplier: filters.supplier || "",
        status: filters.status || "",
        date_range: filters.date_range || "today",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
      responseType: "blob", // ✅ Important for file download
    });
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    throw new Error("Failed to export Excel");
  }
};

// post purchase voucher

export const CreatePurchaseVoucher = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.post(`accountent/purchase-vouchers/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // 👈 JSON nahi, multipart
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Create Error:", err.response?.data || err.message);
    throw err;
  }
};

// put purchase voucher

export const UpdatePurchaseVoucher = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(
    `accountent/purchase-vouchers/${id}/`,
    fromData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("Update Purchase Voucher Error:", err);
  });
  return response ? response.data : {};
};

// delete purchase voucher

export const DeletePurchaseVoucher = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  return await API.delete(`accountent/purchase-vouchers/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

//Generate purchase voucher no
export const GetNextPvNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/generate-purchase-voucher-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};
export const GetPurchaseVoucherReportList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`report/purchase-vouchers-report/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
//approve purchase
export const ApprovePurchaseVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-purchase/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch(() => null);

  return response ? response.data : {};
};

export const GetApprovedPVs = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/approve-purchase/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
// =====================================================================
//created by anjali 14-07-2025

// 🔸 Get All Payment details
export const fetchPaymentDetails = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/daily-payments/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
//  create payment in by month and year

export const fetchPaymentDetailsByYearMonth = async (year, month) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(
    `report/payments-by-year-month/${year}/${month}/`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("Fetch Payment Error:", err);
  });

  return response ? response.data : {};
};

// create payment out by month and year
export const fetchPaymentDetailsByYearMonthOut = async (year, month) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(
    `report/payments-by-year-month-out/${year}/${month}/`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("Fetch Payment Error:", err);
  });

  return response ? response.data : {};
};

// 🔸 Create new Payment

export const PaymentDetailsCreate = async (payload) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const isFormData = payload instanceof FormData;

  try {
    const response = await API.post("accountent/daily-payments/", payload, {
      headers: {
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Create Error:", err.response?.data || err);
    throw err;
  }
};

//Update Daily Payments
export const DailyPaymentUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  return await API.put(`accountent/daily-payments/${id}/`, formData, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// 🔸 delete Payment detail

export const DailyPaymentDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  return await API.delete(`accountent/daily-payments/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

//approvePayment
export const ApprovePaymentVoucher = async (
  payment_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-payment/${payment_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};
// ===================================================================================

// purchase vouchare crud operation
// created by himanshu 23-06-2025

// Sales Voucher crud

export const ApproveSalesVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-sales/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );
  return response?.data || {};
};
export const SalesVoucherCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`/accountent/sales-voucher/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Error:", err);
  });
  return response ? response.data : {};
};

export const GetSalesVoucherList = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/sales-voucher/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      sales_no: filters.sales_no,
      project_name: filters.project_name,
      party_name: filters.party_name,
      status: filters.status,
      date_range: filters.date_range,
      from_date: filters.from_date,
      to_date: filters.to_date,
      salevoucher_date_from: filters.salevoucher_date_from,
      salevoucher_date_to: filters.salevoucher_date_to,
      // invoice_date: filters.invoice_date
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GetSalesVoucherById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/sales-voucher/${id}/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
export const SalesVoucherDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`/accountent/sales-voucher/${id}/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const SalesVoucherUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`/accountent/sales-voucher/${id}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GenerateSalesVoucherNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  return await API.get(`/accountent/generate-sales-voucher-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  });
};

// Payment Voucher

export const ApproveAccountsPaymentVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-payment-voucher/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );
  return response?.data || {};
};
export const PaymentVoucherCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`accountent/payment-voucher/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Error:", err);
  });
  return response ? response.data : {};
};

// Services.js

export const PaymentVoucherExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      "accountent/payment-vouchers/export-excel/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          payment_mode: filters.payment_mode || "",
          bank_id: filters.bank_id || "",
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Payment Voucher Export Error:", error);
    throw error;
  }
};

export const GetPaymentVoucherList = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/payment-voucher/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      payment_no: filters.payment_no || "",
      project_name: filters.project_name || "",
      ledger: filters.ledger || "",
      bank_id: filters.bank_id || "",
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
      payment_mode: filters.payment_mode || "",
      status: filters.status,
      payment_date_from: filters.payment_date_from || "",
      payment_date_to: filters.payment_date_to || "",
      // payment_date: filters.payment_date || "",
      payment_mode: filters.payment_mode || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const BankAccountList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(`account/bank-details/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Bank List Error:", err);
    return [];
  }
};

export const GetPaymentVoucherById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/payment-voucher/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
export const PaymentVoucherDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`accountent/payment-voucher/${id}/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const PaymentVoucherUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(
    `accountent/payment-voucher/${id}/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GeneratePaymentVoucherNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/generate-payment-voucher-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  });
  return response ? response.data : {};
};

// Receipt Voucher

export const ApproveReceiptVoucher = async (
  voucher_no,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `/accountent/approve-receipt/${voucher_no}/`,
    {
      approved_by: approverId,
      status: status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );
  return response?.data || {};
};
export const ReceiptVoucherCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`accountent/receipt-voucher/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Error:", err);
  });
  return response ? response.data : {};
};

export const GetReceiptVoucherList = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/receipt-voucher/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      receipt_number: filters.receipt_number || "",
      pi_no: filters.pi_no || "",
      project: filters.project || "",
      sales_number: filters.sales_number || "",
      status: filters.status || "",
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
      invoice_date: filters.invoice_date || "",
      party: filters.party || "",
      receipt_date_from: filters.receipt_date_from || "",
      receipt_date_to: filters.receipt_date_to || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GetReceiptVoucherById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/receipt-voucher/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
export const ReceiptVoucherDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.delete(`accountent/receipt-voucher/${id}/`, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ReceiptVoucherUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(
    `accountent/receipt-voucher/${id}/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "multipart/form-data",
      },
    },
  ).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GenerateReceiptVoucherNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  return await API.get(`accountent/generate-receipt-voucher-no/`, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
// Ledger get

export const LedgerGet = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/ledger/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params,
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
// Services.js

//Excel API
export const LedgerEntryExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("accountent/ledger-entries/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        id: filters.id || "",
        type: filters.type || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        search: filters.search || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Ledger Export Error:", error);
    throw error;
  }
};

export const MaterialIssueExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("accountent/ledger-entries/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        id: filters.id || "",
        type: filters.type || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        search: filters.search || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Ledger Export Error:", error);
    throw error;
  }
};
export const CashTransactionsGet = async (params = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const queryString = new URLSearchParams(params).toString();
  const url = `accountent/cash-transactions-ledger/${queryString ? `?${queryString}` : ""}`;

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
    },
  }).catch((err) => {
    console.error("Cash Transactions Error:", err);
  });

  return response ? response.data : [];
};

// Services.js

export const CashTransactionsExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      "accountent/cash-transactions/export-excel/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Cash Export Error:", error);
    throw error;
  }
};
// 🔸 Create Purchase Voucher
export const PurchaseVoucherCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`purchase/purchase-voucher/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Create Error:", err);
  });
  return response ? response.data : {};
};

// 🔸 Get All Purchase Vouchers
export const PurchaseVoucherList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`purchase/purchase-vouchers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const GetConsumptionReport = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // Build query params
  const params = new URLSearchParams({
    page: page.toString(),
    ...filters,
  });
  const response = await API.get(
    `inventory/api/consumption-report/?${params.toString()}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch((err) => {
    console.error("Consumption Report Error:", err);
  });

  return response ? response.data : {};
};

export const ExportConsumptionReport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("inventory/api/item-consumption/export/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        category: filters.category || "",
        item_type: filters.item_type || "",
        sub_category: filters.sub_category || "",
        item_name: filters.item_name || "",
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Consumption Export Error:", error);
    throw error;
  }
};

// 🔸 Delete a Voucher
export const PurchaseVoucherDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`purchase/purchase-voucher/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Delete Error:", err);
  });
  return response ? response.data : {};
};

// 🔸 Update a Voucher (PUT or PATCH)

export const PurchaseVoucherUpdate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.put(`purchase/purchase-voucher/${id}/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Update Purchase Voucher Error:", err);
  });
  return response ? response.data : {};
};

// sales vouchare crud operation
// created by himanshu 23-06-2025

// get generate so no
export const GetNextSoNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`sale/generate-so-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};

// suppiler crud operation
// created by himanshu 23-06-2025

//vendor
export const vendorCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`purchase/suppliers/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};
export const vendorUpdate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`purchase/suppliers/${id}/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// export const fetchSuppliers = async ({ page = 1, search = "" }) => {
//   const access = JSON.parse(localStorage.getItem("access"));
//   const response = await API.get(`purchase/suppliers/`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access}`,
//     },
//     params: {
//       page,
//       name: search,
//     },
//   }).catch((err) => {
//     console.error("List Error:", err);
//   });

//   return response ? response.data : {};
// };

export const fetchSuppliers = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get("purchase/suppliers/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: { page, name: filters.name || "" }, // ✅ filter by name if provided
  }).catch((err) => {
    console.error("List Error:", err);
  });

  // Ensure array return
  return response?.data?.results || [];
};

export const GetApprovedSuppliers = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`purchase/approved-suppliers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const deleteVendor = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`purchase/suppliers/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Delete Error:", err);
  });
  return response ? response.data : {};
};

//Purchase Order
export const postpos = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`purchase/purchase-orders/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const fetchpos = async (filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`purchase/purchase-orders/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      po_number: filters.po_number || "",
      supplier: filters.supplier || "",
      approval_status: filters.approval_status || "",
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const fetchposReport = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`report/purchase-orders-report/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response.data.results || response.data; // adjust based on shape
};

export const deletepos = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`purchase/purchase-orders/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};
export const updatepos = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`purchase/purchase-orders/${id}/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

//proforma invoice
export const GetNextPoNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`purchase/generate-po-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};
export const ProformaInvoiceCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post(`sale/proforma-invoices/`, formData, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error; // Important: Error ko properly throw karna hai
  }
};

export const ProformaInvoiceListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("sale/proforma-invoices/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        division: filters.division || "",
        pi_no: filters.pi_no || "",
        project_name: filters.project_name || "",
        status: filters.status || "",
        // pi_date: filters.pi_date || "",
        pi_date_from: filters.pi_date_from || "",
        pi_date_to: filters.pi_date_to || "",
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
    });

    return response.data;
  } catch {
    return { results: [], count: 0 };
  }
};
// Services.js me add karo

export const ProformaInvoiceExportExcel = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("sale/proforma-invoices/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        division: filters.division || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        pi_no: filters.pi_no || "",
        project_name: filters.project_name || "",
        status: filters.status || "",
        pi_date: filters.pi_date || "",
      },
      responseType: "blob", // 👈 Important for file download
    });

    return response.data; // Returns blob
  } catch (error) {
    console.error("Excel Export Error:", error);
    throw error;
  }
};

export const ProformaInvoiceReportListApi = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("report/proforma-invoices-report/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        company_name: filters.company_name || "",
        client_name: filters.client_name || "",
        invoice_number: filters.invoice_number || "",
        project_name: filters.project_name || "",
        status: filters.status || "",
      },
    });

    return response.data;
  } catch {
    return { results: [], count: 0 };
  }
};

export const ProformaInvoiceDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`sale/proforma-invoices/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const ProformaInvoiceUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`sale/proforma-invoices/${id}/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const ProformaInvoiceDetail = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale/proforma-invoices/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};
//get generate pi no
export const GetNextPiNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`sale/generate-pi-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate PI No. Error:", err);
  });

  return response ? response.data : {};
};

export const GetLastInvoiceByProject = async (projectId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale/proforma-invoices/last/${projectId}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};
export const ApproveProformaInvoice = async (
  id,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(
    `/sale/approve-proforma/${id}/`,
    {
      approved_by: approverId, // kisne approve/unapprove kiya
      status: status,
      remarks, // true = approve, false = unapprove
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch(() => null);

  return response ? response.data : {};
};

//inventory

export const GoodReceivedCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`inventory/goods-received/`, formData, {
    headers: {
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);

  return response ? response.data : {};
};

// export const GoodReceivedList = async (page = 1, search = "") => {
//   const access = JSON.parse(localStorage.getItem("access"));
//   try {
//     const response = await API.get(`inventory/goods-received/`, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${access}`,
//       },
//       params: {
//         page: page,
//         search: search || undefined,  // optional
//       },
//     });
//     return response.data;  // {count, next, previous, results}
//   } catch (err) {
//     console.error(err);
//     return null;
//   }
// };
export const GoodReceivedList = async (page = 1, projectName = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`inventory/goods-received/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page: page,
        project_name: projectName || undefined, // ✅ backend param ke hisaab se
      },
    });
    return response.data; // {count, next, previous, results}
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const GoodReceivedDetail = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`inventory/goods-received/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);

  return response ? response.data : {};
};

export const GoodReceivedUpdate = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`inventory/goods-received/${id}/`, formData, {
    headers: {
      Authorization: `Bearer ${access}`,
      "Content-Type": "application/json",
    },
  }).catch(() => null);

  return response ? response.data : {};
};
export const GetNextGRNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`inventory/generate-goods-received-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};

export const GoodReceivedDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`inventory/goods-received/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);

  return response ? response.data : {};
};

// Created by harish sen on 26-06-2025

export const createItem = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`inventory/items/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const getAllItems = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/items/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        // search_item_type: filters.search_item_type || "",
        item_code: filters.item_code || "",
        category_name: filters.category || "",
        store_item_type: filters.store_item_type || "",
        name: filters.name || "",
        sub_category: filters.sub_category || "",
        item_size: filters.item_size || "",
        item_type: filters.item_type || "",
        // date_range: filters.date_range || "",
        date_range: filters.date_range || "all",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
    });
    return response.data;
  } catch {
    return { results: [] };
  }
};

export const ExportItemConsumptionReport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      "inventory/issue-items/division-items-export/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          division_id: filters.division_id || "",
          item: filters.item || "",
          date_range: filters.date_range || "today",
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Item Consumption Export Error:", error);
    throw error;
  }
};

export const exportStockSummary = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/items/export/", {
      // ✅ Different endpoint
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        item_code: filters.item_code || "",
        name: filters.name || "",
        category: filters.category_name || "",
        sub_category: filters.sub_category || "",
        item_type: filters.item_type || "",
      },
      responseType: "blob", // ✅ Important for file download
    });
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    throw new Error("Failed to export Excel");
  }
};

export const ValueOfClosingStockExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      "inventory/items/value-of-closing-stock-export/",
      {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: {
          item_code: filters.item_code || "",
          name: filters.name || "",
          category: filters.category_name || "",
          sub_category: filters.sub_category || "",
          item_type: filters.item_type || "",
        },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    throw new Error("Failed to export Excel");
  }
};

export const checkItemCode = async (item_code, item_id = null) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`inventory/check-item-code/`, {
    params: { item_code, item_id },
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data; // { exists: true/false }
};

// Debounced version
export const debouncedGetAllItems = debounce(getAllItems, 500);
export const getItemById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`inventory/item/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const deleteItem = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`inventory/item/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const updateItem = async (item_id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`inventory/item/${item_id}/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// export const getCategories = async (page = 1, search = "", pageSize = 20) => {
//   try {
//     const response = await API.get(
//       `inventory/categories/?page=${page}&page_size=${pageSize}&search=${search}`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${access}`,
//         },
//       }
//     );
//     return response.data; // yahan ab object milega {count, next, previous, results}
//   } catch (error) {
//     return { results: [], count: 0, next: null, previous: null };
//   }
// };

// same for Units: getUnits, createUnit, updateUnit, deleteUnit

// ✅ GET all issues
export const getIssues = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/issues/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        page_size: filters.pageSize || 10,
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        item: filters.item || "",
        slip_no: filters.slip_no || "",
        project_name: filters.project_name || "",
        division_name: filters.division_name || "",
        division_id: filters.division_id || "",
      },
    });
    return response.data; // {count, next, previous, results: [...]}
  } catch {
    return { results: [] };
  }
};

export const getIssuesitemdetail = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/issue-item-details/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        page_size: filters.pageSize || 10,
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        item: filters.item || "",
        project_name: filters.project_name || "",
        division_id: filters.division_id || "",
      },
    });
    return response.data; // {count, next, previous, results: [...]}
  } catch {
    return { results: [] };
  }
};
// Services.js

export const exportIssueItems = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/issue-items/export/", {
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        slip_no: filters.slip_no || "",
        project_name: filters.project_name || "",
        division_name: filters.division_name || "",
        division: filters.division || "",
        division_id: filters.division_id || "",
        item: filters.item || "",
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    throw new Error("Failed to export Excel");
  }
};

export const exportDivisionWiseIssue = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      "inventory/issue-items/division-wise-export/",
      {
        headers: {
          Authorization: `Bearer ${access}`,
        },
        params: {
          division: filters.division || "",
          date_range: filters.date_range || "",
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    throw new Error("Failed to export Excel");
  }
};
export const JournalVoucherExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("report/journal-vouchers/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        division_id: filters.division_id || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Journal Voucher Export Error:", error);
    throw error;
  }
};

export const SalesOrderExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("sale/sales-orders/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        party: filters.party || "",
        division: filters.division || "",
        project_name: filters.project_name || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        date_range: filters.date_range || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Sales Order Export Error:", error);
    throw error;
  }
};

export const getJournalVouchersbydivision = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`report/journal-voucher-by-division/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      division_id: filters.division_id || "",
      date_range: filters.date_range || "",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });

  return response ? response.data : {};
};

// ✅ CREATE new issue
export const createIssue = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/issues/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const GetNextGoodsOutNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`inventory/generate-goods-out-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};
// ✅ UPDATE issue
export const updateIssue = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/issues/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ DELETE issue
export const deleteIssue = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.delete(`inventory/issues/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};
export const getIssueById = async (id) => {
  const response = await fetch(`inventory/issues/${id}/`);
  const data = await response.json();
  return data;
};

export const getTransactions = async () => {
  const res = await API.get("/inventory/transactions/");
  return res.data;
};

export const createTransaction = async (data) => {
  const res = await API.post("/inventory/transactions/", data);
  return res.data;
};

export const deleteTransaction = async (id) => {
  const res = await API.delete(`/inventory/transaction/${id}/`);
  return res.data;
};

export const getPurchaseOrders = async () => {
  const res = await API.get("/purchase/orders/");
  return res.data;
};

// export const BankDetailList = async (params = {}) => {
//   const res = await API.get(`account/bank-details/`, { params });
//   return res.data;
// };

export const BankLedgerApi = async (bankId, filters = {}, page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`account/api/banks/${bankId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        date_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        page,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bank ledger:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch ledger",
      summary: null,
      entries: [],
    };
  }
};

export const DebtorLedgerApi = async (partyId, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(`sale/api/parties/${partyId}/ledger/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching party ledger:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch ledger",
      summary: null,
      entries: [],
    };
  }
};

export const SupplierLedgerApi = async (supplierId, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      `purchase/api/suppliers/${supplierId}/ledger/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching supplier ledger:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch ledger",
      summary: null,
      entries: [],
    };
  }
};

export const BankDetailList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("account/bank-details/", {
      headers: {
        "Content-Type": "application/j son",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        account_number: filters.account_number || "",
        account_type: filters.account_type || "",
      },
    });
    return response.data;
  } catch {
    return { results: [] };
  }
};

// Services.js

export const BankLedgerExport = async (bankId, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      `account/bank-ledger/${bankId}/export-excel/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Bank Ledger Export Error:", error);
    throw error;
  }
};
export const BankDetailCreate = async (data) => {
  const res = await API.post(`account/bank-details/`, data);
  return res.data;
};

export const BankDetailUpdate = async (id, data) => {
  const res = await API.put(`account/bank-details/${id}/`, data);
  return res.data;
};

export const BankDetailDelete = async (id) => {
  const res = await API.delete(`account/bank-details/${id}/`);
  return res.status === 204 || res.status === 200;
};

// Create a new payment entry
export const createDailyPayment = async (formData) => {
  try {
    const response = await API.post(`accountent/payments/`, formData);
    return response.data;
  } catch (error) {
    console.error("Create error:", error);
    return {};
  }
};

// Get all payments
export const fetchDailyPayments = async () => {
  try {
    const response = await API.get(`accountent/payments/`);
    return response.data;
  } catch (error) {
    console.error("Fetch list error:", error);
    return [];
  }
};

// Get a single payment by ID
export const getDailyPaymentById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`payments/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Fetch by ID error:", error);
    return {};
  }
};

// Update a payment by ID
export const updateDailyPayment = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.put(`payments/${id}/`, formData);
    return response.data;
  } catch (error) {
    console.error("Update error:", error);
    return {};
  }
};

// Delete a payment by ID
export const deleteDailyPayment = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.delete(`payments/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Delete error:", error);
    return {};
  }
};

//Create
export const createTransporter = async (formdata) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.post(`inventory/transporter/`, formdata);
    return response.data;
  } catch (error) {
    console.error("Fetch list error:", error);
    return [];
  }
};

//All Transporter
export const getAllTransporter = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/transporter/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        name: filters.transporter_name || "", // transporter name
        account_no: filters.account_no || "",
        pan_no: filters.pan_no || "",
      },
    });
    return response.data;
  } catch {
    return { results: [], next: null };
  }
};

// ✅ Approve/Reject Transporter
export const ApproveTransporter = async (
  transporterId,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.patch(
      `inventory/transporter/${transporterId}/approve/`,
      {
        authorized_by: approverId, // kisne approve/reject kiya
        status: status, // "Approved", "Rejected", "Pending"
        remarks: remarks, // approval/rejection remarks
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Approve/Reject error:", error);
    return {};
  }
};

//Single Transporter
export const getSingleTransporter = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`/inventory/transporter/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Fetch by ID error:", error);
    return {};
  }
};

// Update a Transporter by ID
export const updateTrasnporter = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.put(`inventory/transporter/${id}/`, formData);
    return response.data;
  } catch (error) {
    console.error("Update error:", error);
    return {};
  }
};

// Delete a Transporter by ID
export const deleteTransporter = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.delete(`inventory/transporter/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Delete error:", error);
    return {};
  }
};

export const ApprovePO = async (poId, approverId, approval_status, remarks) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(
    `purchase/approve-po/${poId}/`,
    {
      authorized_by: approverId,
      approval_status: approval_status,
      remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );
  return response?.data || {};
};

export const GetApprovedPOs = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`purchase/approve-po/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  });
  return response?.data || {};
};

// ✅ GET all transfers
// export const getTransfers = async (page = 1, searchFrom = "", searchTo = "") => {
//   // 🔹 ensure token is available
//   const access = JSON.parse(localStorage.getItem("access"));
//   const response = await API.get(`inventory/transfers/`, {
//     params: {
//       page,
//       from_project: searchFrom,
//       to_project: searchTo,
//     },
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access}`,
//     },
//   }).catch(() => null);

//   return response ? response.data : { results: [] };
// };

export const getTransfers = async (
  page = 1,
  searchFromOrFilters = "",
  searchTo = "",
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // ✅ Check if first param is object (new way) or string (old way)
  let params;
  if (typeof searchFromOrFilters === "object") {
    // New way: filters object
    params = {
      page,
      from_project: searchFromOrFilters.from_project || "",
      to_project: searchFromOrFilters.to_project || "",
      date_range: searchFromOrFilters.date_range || "",
      from_date: searchFromOrFilters.from_date || "",
      to_date: searchFromOrFilters.to_date || "",
    };
  } else {
    // Old way: individual string params
    params = {
      page,
      from_project: searchFromOrFilters || "",
      to_project: searchTo || "",
      date_range: "",
      from_date: "",
      to_date: "",
    };
  }

  const response = await API.get(`inventory/transfers/`, {
    params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);

  return response ? response.data : { results: [] };
};

export const getTransfersHistory = async (
  page = 1,
  searchFrom = "",
  searchTo = "",
) => {
  // 🔹 ensure token is available
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`report/transfers-history/`, {
    params: {
      page,
      from_project: searchFrom,
      to_project: searchTo,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);

  return response ? response.data : { results: [] };
};

// ✅ GET single transfer by ID
export const getTransferById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`inventory/transfers/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ CREATE new transfer
export const createTransfer = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post(`inventory/transfers/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ UPDATE existing transfer
export const updateTransfer = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`inventory/transfers/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const TransferDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`inventory/transfers/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const GetNextTransferNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`inventory/generate-transfer-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};

//Dashboard counts

export const getDashboardCounts = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get("sale/dashboard-counts/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return res ? res.data : {};
};

export const StocksDashboardCounts = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get("inventory/stocks-dasboard-counts/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return res ? res.data : {};
};

export const PurchaseDashboardCounts = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get("purchase/purchase-dashboard/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return res ? res.data : {};
};

export const getMainDashboardCounts = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get("report/main-dashboard-count/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Error fetching main dashboard counts:", err);
  });

  return res ? res.data : {};
};

// ✅ GET all imprest records
export const ImprestMasterList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`accountent/imprest/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ GET single imprest by ID
export const ImprestMasterRetrieve = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.get(`accountent/imprest/${id}/`, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ CREATE new imprest
export const ImprestMasterCreate = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post("accountent/imprest/", data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ UPDATE existing imprest
export const ImprestMasterUpdate = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`accountent/imprest/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ DELETE imprest
export const ImprestMasterDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`accountent/imprest/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const ApproveAdvanceWorker = async (
  workerId,
  approverId,
  approvalStatus,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `accountent/advance-workers/${workerId}/approve/`,
    {
      authorized_by: approverId,
      approval_status: approvalStatus,
      remarks: remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

export const ApproveImprestMaster = async (
  imprestId,
  approverId,
  approvalStatus,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `accountent/imprest-masters/${imprestId}/approve/`,
    {
      authorized_by: approverId,
      approval_status: approvalStatus, // ✅ approval_status
      remarks: remarks,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

export const ApproveExpense = async (
  expenseId,
  approverId,
  status,
  remarks,
) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.patch(
    `accountent/approve-expense/${expenseId}/`,
    {
      authorized_by: approverId, // kisne approve/reject kiya
      status: status, // "Approved", "Rejected", "Pending"
      remarks: remarks, // remark text
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  );

  return response?.data || {};
};

export const ApproveSalesVoucherList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/approve-sales-list/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ApprovePartyList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/sale/approve/party/`, {
    headers: {
      "Content-Type": "application/json", // ✅ multipart नहीं चाहिए GET में
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });

  // ✅ results array return करो
  if (!response) return [];
  
  const data = response.data;
  console.log("ApprovePartyList raw data:", data); // debug
  
  // Paginated response → results array
  if (Array.isArray(data?.results)) return data.results;
  // Direct array
  if (Array.isArray(data)) return data;
  
  return [];
};
export const ApproveExpenseList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/approve-expense/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ApproveImprestList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/imprest-masters/approve/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ApproveAdvworkerList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`/accountent/advance-workers/approve/`, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      name: filters.name || "",
    },
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const ApproveProformaInvoiceList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`sale/approve-proforma-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate PI No. Error:", err);
  });

  return response ? response.data : {};
};

// advance worker

export const getadvanceworker = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/ad-worker/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate PI No. Error:", err);
  });

  return response ? response.data : {};
};
// DELETE imprest
export const deleteadworker = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`/accountent/ad-worker/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// ✅ UPDATE existing imprest
export const Updateadworker = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.put(`accountent/ad-worker/${id}/`, data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

// ✅ CREATE new imprest
export const postadworker = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const res = await API.post("/accountent/ad-worker/", data, {
    headers: { Authorization: `Bearer ${access}` },
  });
  return res.data;
};

export const SalesOrderbydateListApi = async (page, filters) => {
  try {
    const token = JSON.parse(localStorage.getItem("access")); // ya "token" based on your login logic
    const params = {};

    if (filters.from_date) params.from_date = filters.from_date;
    if (filters.to_date) params.to_date = filters.to_date;
    if (filters.id) params.id = filters.id;
    if (filters.project_name) params.project_name = filters.project_name;
    if (page) params.page = page;

    const response = await API.get(`sale/api/salesorders-bydate/`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Sales Orders:", error);
    return { results: [], next: null };
  }
};

// Stock ledger list
export const StockLedgerList = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`accountent/stock-ledger/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: params, // ✅ Pass search & other query parameters
  }).catch((err) => {
    console.error("List Error:", err);
  });
  return response ? response.data : {};
};

export const StockLedgerExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(`accountent/stock-ledger/excel/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        data_range: filters.date_range || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Bank Ledger Export Error:", error);
    throw error;
  }
};

export const BankLedgerbydateListApi = async (page, filters) => {
  try {
    const token = JSON.parse(localStorage.getItem("access")); // ya "token" based on your login logic
    const params = {};

    if (filters.from_date) params.from_date = filters.from_date;
    if (filters.to_date) params.to_date = filters.to_date;
    if (filters.id) params.id = filters.id;
    if (filters.project_name) params.project_name = filters.project_name;
    if (page) params.page = page;

    const response = await API.get(`account/api/bankledger-bydate/`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Sales Orders:", error);
    return { results: [], next: null };
  }
};

export const ItemListExport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("inventory/items/item-list-export/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        item_code: filters.item_code || "",
        category_name: filters.category_name || "",
        sub_category: filters.sub_category || "",
        item_size: filters.item_size || "",
        name: filters.name || "",
        date_range: filters.date_range || "today",
      },
      responseType: "blob", // ✅ Important for file download
    });
    return response.data;
  } catch (error) {
    console.error("Export error:", error);
    throw error;
  }
};

export const ExportPaymentVoucherExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get("accountent/payment-cash/export-excel/", {
      params: params,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Export Excel Error:", error);
    throw error;
  }
};

export const ExportPaymentBankExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get("accountent/payment-bank/export-excel/", {
      params: params,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Export Bank Excel Error:", error);
    throw error;
  }
};

export const ExportReceiptVoucherExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get("accountent/receipt-voucher/export-excel/", {
      params: params,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Export Receipt Excel Error:", error);
    throw error;
  }
};

export const ExportContraVoucher = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("accountent/contravoucher/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Contra Voucher Export Error:", error);
    throw error;
  }
};

export const GeneralVoucherExportApi = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("accountent/generalvoucher/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("General Voucher Export Error:", error);
    throw error;
  }
};

export const ExportPurchaseVouchersToExcel = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      "accountent/purchase-vouchers/export-excel/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: filters,
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Purchase Voucher Export Error:", error);
    throw error;
  }
};

export const SalesListExport = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("accountent/sales-list/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: params,
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Sales Order Export Error:", error);
    throw error;
  }
};

export const ExportSalesVouchersToExcel = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("accountent/sales-vouchers/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Sales Voucher Export Error:", error);
    throw error;
  }
};

export const ProformaInvoiceExportApi = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("accountent/proformatable/export-excel/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
      responseType: "blob",
    });

    return response.data;
  } catch (error) {
    console.error("Proforma Table Export Error:", error);
    throw error;
  }
};

// Fetch Design & Drawing List
export const fetchDesignAndDrawing = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("operational/design-and-drawing/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        limit: filters.limit || 100,
        project: filters.project || "",
        debitor: filters.debitor || "",
        division: filters.division || "",
      },
    });
    console.log(response.data, "oodkjfglsjdrogl");

    return response.data;
  } catch (err) {
    console.error("Error fetching Design & Drawing:", err);
    return { results: [], next: null };
  }
};

// Create Design & Drawing
export const createDesignAndDrawing = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post(
      "operational/design-and-drawing/",
      formData,
      {
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    console.log(response.data, "oidifjgo");
    return response.data;
  } catch (err) {
    console.error("Error creating Design & Drawing:", err);
    return {};
  }
};

export const updateDesignAndDrawing = async (id, updatedData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(
      `operational/design-and-drawing/${id}/`, // 👈 Django route ke hisab se
      updatedData, // e.g. { amount: 500, remarks: "Updated" }
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      },
    );

    return response.data; // { success: "...", data: {...} }
  } catch (err) {
    console.error("Update Contra Voucher Error:", err);
    return {};
  }
};

export const deleteDesignAndDrawing = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`operational/design-and-drawing/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// IBRFormaLities
export const fetchIBRFormaLities = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("operational/ibr-formalities/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        limit: filters.limit || 100,
        project: filters.project || "",
        debitor: filters.debitor || "",
        division: filters.division || "",
      },
    });
    console.log(response.data, "oodkjfglsjdrogl");

    return response.data;
  } catch (err) {
    console.error("Error fetching Design & Drawing:", err);
    return { results: [], next: null };
  }
};
export const createIBRFormaLities = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post("operational/ibr-formalities/", formData, {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data, "oidifjgo");
    return response.data;
  } catch (err) {
    console.error("Error creating Design & Drawing:", err);
    return {};
  }
};

export const updateIBRFormaLities = async (id, updatedData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(
      `operational/ibr-formalities/${id}/`, // 👈 Django route ke hisab se
      updatedData, // e.g. { amount: 500, remarks: "Updated" }
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      },
    );

    return response.data; // { success: "...", data: {...} }
  } catch (err) {
    console.error("Update Contra Voucher Error:", err);
    return {};
  }
};

export const deleteIBRFormaLities = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`operational/ibr-formalities/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Projects by Debitor/Supplier ID
export const GetProjectsByDebitor = async (
  debitorId,
  page = 1,
  filters = {},
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`sale//`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      debitor_id: debitorId,
      project_name: filters.project_name || "",
    },
  }).catch((err) => {
    console.error("Projects Error:", err);
  });
  return response ? response.data : {};
};

// Get Divisions by Project ID
export const GetDivisionsByProject = async (
  projectId,
  page = 1,
  filters = {},
) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`divisions/by-project/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      project_id: projectId,
      division_name: filters.division_name || "",
    },
  }).catch((err) => {
    console.error("Divisions Error:", err);
  });
  return response ? response.data : {};
};

// ========== IBR FORMALITIES API FUNCTIONS ==========

// Fetch IBR Formalities
export const fetchIBRFormalities = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("operational/ibr-formalities/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        limit: filters.limit || 100,
        project: filters.project || "",
        debitor: filters.debitor || "",
        division: filters.division || "",
      },
    });
    console.log(response.data, "IBR Formalities Data");

    return response.data;
  } catch (err) {
    console.error("Error fetching IBR Formalities:", err);
    return { results: [], next: null };
  }
};

// Create IBR Formality
export const createIBRFormalities = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post("operational/ibr-formalities/", formData, {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data, "IBR Formality Created");
    return response.data;
  } catch (err) {
    console.error("Error creating IBR Formality:", err);
    return {};
  }
};

// Update IBR Formality
export const updateIBRFormalities = async (id, updatedData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(
      `operational/ibr-formalities/${id}/`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "multipart/form-data", // Changed to multipart for file uploads
        },
      },
    );

    console.log(response.data, "IBR Formality Updated");
    return response.data;
  } catch (err) {
    console.error("Error updating IBR Formality:", err);
    return {};
  }
};

// Delete IBR Formality
export const deleteIBRFormalities = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.delete(`operational/ibr-formalities/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    console.log(response.data, "IBR Formality Deleted");
    return response ? response.data : {};
  } catch (err) {
    console.error("Error deleting IBR Formality:", err);
    return {};
  }
};

export const getAllMTC = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("inventory/mtc/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        limit: filters.limit || 100,
        tc_no: filters.tc_no || "",
        heat_no: filters.heat_no || "",
        size: filters.size || "",
      },
    });
    console.log(response.data, "MTC Data");

    return response.data;
  } catch (err) {
    console.error("Error fetching MTC list:", err);
    return { results: [], next: null };
  }
};

// Create MTC
export const createMTC = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.post("inventory/mtc/", formData, {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data, "Bulk MTC Created");
    return response.data;
  } catch (err) {
    console.error("Error creating bulk MTC:", err);
    throw err;
  }
};

// Update MTC
export const updateMTC = async (id, updatedData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.put(`inventory/mtc/${id}/`, updatedData, {
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data, "MTC Updated");
    return response.data;
  } catch (err) {
    console.error("Error updating MTC:", err);
    return {};
  }
};

// Delete MTC
export const deleteMTC = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.delete(`inventory/mtc/${id}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    console.log(response.data, "MTC Deleted");
    return response ? response.data : {};
  } catch (err) {
    console.error("Error deleting MTC:", err);
    return {};
  }
};

// Export MTC to Excel
export const exportMTCExcel = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get("inventory/mtc/export/", {
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        tc_no: filters.tc_no || "",
        heat_no: filters.heat_no || "",
      },
      responseType: "blob",
    });

    console.log("MTC Excel Export Successful");
    return response.data;
  } catch (err) {
    console.error("Error exporting MTC to Excel:", err);
    throw err;
  }
};

export const ApproveIndentReport = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`purchase/approve-indent-report/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      indent_no: filters.indent_no || "",
      project_name: filters.project_name || "",
      date_range: filters.date_range || "this_month",
      from_date: filters.from_date || "",
      to_date: filters.to_date || "",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// ✅ Updated Service API with all parameters
export const GetApprovedPoReport = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const params = {
    page,
    po_number: filters.po_number || "",
    supplier: filters.supplier || "",
    date_range: filters.date_range || "today",
  };

  if (filters.date_range === "custom") {
    params.from_date = filters.from_date || "";
    params.to_date = filters.to_date || "";
  }

  try {
    const response = await API.get(`purchase/approve-po-report/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params,
    });
    return response?.data || { results: [], next: null, count: 0 };
  } catch (error) {
    console.error("Error fetching approved POs:", error);
    return { results: [], next: null, count: 0 };
  }
};

// Get Approved Purchase Orders by Division and Indent
export const GetApprovedPurchaseOrders = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `purchase/approved-purchase-orders-by-indent/`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        division: filters.division || "",
        indent_no: filters.indent_no || "",
        indent_id: filters.indent_id || "",
        status: filters.status || "Approved",
        page: filters.page || 1,
      },
    },
  ).catch(() => null);
  return response ? response.data : {};
};

// Export Purchase Orders to Excel
export const exportPurchaseOrdersExcel = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      "purchase/export-purchase-orders-by-indent/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          division: filters.division || "",
          indent_no: filters.indent_no || "",
          indent_id: filters.indent_id || "",
        },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Excel export error:", error);
    return null;
  }
};

export const GetPurchaseOrdersBySupplier = async (supplierId, filters) => {
  const access = JSON.parse(localStorage.getItem("access"));
  
  // ✅ Build params object
  const params = {
    supplier: supplierId,
    status: "Approved",
  };
  if (filters && filters.division) {
    params.division = filters.division;
  }

  const response = await API.get(`purchase/po-by-supplier/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: params,
  }).catch((err) => {
    console.error("Purchase Orders Error:", err);
    return null;
  });
  
  return response ? response.data : {};
};

export const GetPurchaseVoucherByPo = async (filters = {}) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get(`accountent/purchase-voucher-stockreport/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
    });
    return response?.data || {};
  } catch (err) {
    console.error("Purchase Vouchers Error:", err);
    throw err;
  }
};

export const ExportPurchaseVouchersExcel = async (filters = {}) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get(`accountent/export-purchase-vouchers/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: filters,
      responseType: "blob",
    });
    return response?.data || null;
  } catch (err) {
    console.error("Excel Export Error:", err);
    throw err;
  }
};

export const getTCNumbers = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`operational/tc-numbers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      search: filters.search || "",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// Get Issue MTC List
export const getIssueMTCList = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`operational/issue-mtc/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page: filters.page,
      limit: filters.limit || 100,
      search: filters.search || "",
      project: filters.project || "",
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// Get Issue MTC Detail
export const getIssueMTCDetail = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`operational/issue-mtc/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// Create Issue MTC
export const createIssueMTC = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`operational/issue-mtc/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// Update Issue MTC
export const updateIssueMTC = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`operational/issue-mtc/${id}/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

// Delete Issue MTC
export const deleteIssueMTC = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`operational/issue-mtc/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => null);
  return response ? response.data : {};
};

export const UpdateUserRole = async (id, role) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.patch(
      `account/update-role/${id}/`,
      { role: role },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const ExportApprovedPoReport = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.get(
      "purchase/approve-po-report/export/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          date_range: filters.date_range || "",
          from_date: filters.from_date || "",
          to_date: filters.to_date || "",
          po_number: filters.po_number || "",
          supplier: filters.supplier || "",
        },
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("PO Report Export Error:", error);
    throw error;
  }
};

export const ProjectSummaryExport = async (projectId, key = "ALL") => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `report/project/summary/${projectId}/export/`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: { key },          // key="ALL" or key="SO" etc.
      responseType: "blob",     // ← Excel file ke liye zaruri
    }
  );
  return response.data;
};


export const GenerateQuotationNo = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`academic/quotation-no/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Generate SO No. Error:", err);
  });

  return response ? response.data : {};
};